import { render, staticRenderFns } from "./TestingChangeQuestions.vue?vue&type=template&id=5e9c19e4"
import script from "./TestingChangeQuestions.vue?vue&type=script&lang=ts"
export * from "./TestingChangeQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports